<template>
	<v-app class="animated fadeIn background">
		<transition name="fade">
			<toolbar v-if="isAuthenticaded" />
		</transition>
		<v-main>
			<transition name="fade">
				<div>
					<navigation v-if="isAuthenticaded" />
					<router-view />
				</div>
			</transition>
		</v-main>
	</v-app>
</template>
<script>
import { mapGetters } from "vuex";
import toolbar from "./components/toolbar/Toolbar.vue";
import navigation from "./components/navigation/NavigationLinks.vue";

export default {
	name:       "App",
	components: {
		toolbar:    toolbar,
		navigation: navigation,
	},
	computed: { ...mapGetters({ isAuthenticaded: "AccountModule/isAuthenticated", isDark: "isDark" }), },
	created()
	{
		this.$vuetify.theme.dark = this.isDark === null ? false : this.isDark;
	},
};
</script>
<style lang="scss">
@import "./scss/main.scss";
</style>

